import PropTypes from 'prop-types';
import { FormControl, InputLabel, Select, MenuItem, Grid, FormLabel } from '@material-ui/core';

const months = [
  { number: 1, name: 'Janeiro' },
  { number: 2, name: 'Fevereiro' },
  { number: 3, name: 'Março' },
  { number: 4, name: 'Abril' },
  { number: 5, name: 'Maio' },
  { number: 6, name: 'Junho' },
  { number: 7, name: 'Julho' },
  { number: 8, name: 'Agosto' },
  { number: 9, name: 'Setembro' },
  { number: 10, name: 'Outubro' },
  { number: 11, name: 'Novembro' },
  { number: 12, name: 'Dezembro' },
];

// /* eslint-disable */
const MonthYearPicker = ({ label, value, onChange }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(20), (_, index) => currentYear - index);

  const handleMonthChange = (e) => {
    onChange({ ...value, month: e.target.value });
  };

  const handleYearChange = (e) => {
    onChange({ ...value, year: e.target.value });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
      <FormLabel component="legend" style={{ minWidth: 40 }}>
        {label}
      </FormLabel>

      <FormControl variant="outlined" size="small">
        <InputLabel>Mês</InputLabel>
        <Select
          value={value.month}
          onChange={handleMonthChange}
          label="Mês"
        >
          {months.map(({ number, name }) => (
            <MenuItem key={number} value={number}>{name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small">
        <InputLabel>Ano</InputLabel>
        <Select
          value={value.year}
          onChange={handleYearChange}
          label="Ano"
        >
          {years.map((yearOption) => (
            <MenuItem key={yearOption} value={yearOption}>{yearOption}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

MonthYearPicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({
    month: PropTypes.number.isRequired,
    year: PropTypes.number.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MonthYearPicker;